import Style from "./AchievementsSection.module.css";
import useScreenSize from "../../../hooks/useScreenSize";
import AchievementsCard from "./AchievementsCard";
import { useI18n } from "../../../i18n/I18nContext";

export const TextPosition = {
  Left: "left",
  Right: "right",
};

const AchievementsSection = () => {
  const { isSmallSize } = useScreenSize();
  const { copy } = useI18n();
  const achievementsCopy = copy.home.achievements;

  const achievements = [
    {
      textPosition: TextPosition.Right,
      imageSrc: isSmallSize ? "/phone_smartfoodie.png" : "/smartfoodie.png",
      ...achievementsCopy.items[0],
    },
    {
      textPosition: TextPosition.Left,
      imageSrc: isSmallSize ? "/phone_carauction.png" : "/carauction.png",
      ...achievementsCopy.items[1],
    },
    {
      textPosition: TextPosition.Right,
      imageSrc: isSmallSize ? "/phone_modernhouse.png" : "/modernhouse.png",
      ...achievementsCopy.items[2],
    },
  ];

  return (
    <div className={Style["achievements-section-wrapper"]}>
      <h2>{achievementsCopy.title}</h2>
      <div className={Style["achievements-section-body"]} data-nosnippet="">
        {achievements.map((achievement) => (
          <AchievementsCard
            key={achievement.imageSrc}
            textPosition={achievement.textPosition}
            imageSrc={achievement.imageSrc}
            title={achievement.title}
            description={achievement.description}
          />
        ))}
      </div>
    </div>
  );
};

export default AchievementsSection;
